import Joi from 'joi';
// Schéma de validation pour la création d'un utilisateur
export const createUserSchema = Joi.object({
    first_name: Joi.string().min(2).max(255).required().messages({
        'string.base': 'Le prénom doit être une chaîne de caractères.',
        'string.empty': 'Le prénom ne peut pas être vide.',
        'string.min': 'Le prénom doit contenir au moins 2 caractères.',
        'string.max': 'Le prénom ne peut pas dépasser 255 caractères.',
        'any.required': 'Le prénom est obligatoire.',
    }),
    last_name: Joi.string().min(2).max(255).required().messages({
        'string.base': 'Le nom doit être une chaîne de caractères.',
        'string.empty': 'Le nom ne peut pas être vide.',
        'string.min': 'Le nom doit contenir au moins 2 caractères.',
        'string.max': 'Le nom ne peut pas dépasser 255 caractères.',
        'any.required': 'Le nom est obligatoire.',
    }),
    email: Joi.string().email({ tlds: { allow: false } }).max(255).required().messages({
        'string.email': "L'adresse email doit être valide.",
        'string.empty': "L'adresse email ne peut pas être vide.",
        'any.required': "L'adresse email est obligatoire.",
    }),
    password: Joi.string().min(6).required().messages({
        'string.base': 'Le mot de passe doit être une chaîne de caractères.',
        'string.empty': 'Le mot de passe ne peut pas être vide.',
        'string.min': 'Le mot de passe doit contenir au moins 6 caractères.',
        'any.required': 'Le mot de passe est obligatoire.',
    }),
    role_id: Joi.number().integer().required().messages({
        'number.base': "L'ID de rôle doit être un entier.",
        'any.required': 'Le champ "role_id" est obligatoire.',
    }),
    indic_actif: Joi.boolean().default(true).messages({
        'boolean.base': 'Le champ "indic_actif" doit être un booléen.',
    }),
    manager_id: Joi.number().integer().allow(null).messages({
        'number.base': "L'ID du manager doit être un entier.",
    }),
});
// Schéma de validation pour la mise à jour d'un utilisateur
export const updateUserSchema = Joi.object({
    first_name: Joi.string().min(2).max(255).messages({
        'string.base': 'Le prénom doit être une chaîne de caractères.',
        'string.min': 'Le prénom doit contenir au moins 2 caractères.',
        'string.max': 'Le prénom ne peut pas dépasser 255 caractères.',
    }),
    last_name: Joi.string().min(2).max(255).messages({
        'string.base': 'Le nom doit être une chaîne de caractères.',
        'string.min': 'Le nom doit contenir au moins 2 caractères.',
        'string.max': 'Le nom ne peut pas dépasser 255 caractères.',
    }),
    email: Joi.string().email({ tlds: { allow: false } }).max(255).messages({
        'string.email': "L'adresse email doit être valide.",
        'string.max': "L'adresse email ne peut pas dépasser 255 caractères.",
    }),
    password: Joi.string().min(6).messages({
        'string.min': 'Le mot de passe doit contenir au moins 6 caractères.',
    }),
    role_id: Joi.number().integer().messages({
        'number.base': "L'ID de rôle doit être un entier.",
    }),
    indic_actif: Joi.boolean().messages({
        'boolean.base': 'Le champ "indic_actif" doit être un booléen.',
    }),
    manager_id: Joi.number().integer().allow(null).messages({
        'number.base': "L'ID du manager doit être un entier.",
    }),
})
    .or('first_name', 'last_name', 'email', 'password', 'role_id', 'indic_actif', 'manager_id')
    .messages({
    'object.missing': 'Au moins un champ doit être mis à jour.',
});
